import { z } from 'zod';

export const chatThreadIdSchema = z.uuid();
export type ChatThreadId = z.infer<typeof chatThreadIdSchema>;

export const chatMessageIdSchema = z.uuid();
export type ChatMessageId = z.infer<typeof chatMessageIdSchema>;

export const chatEventIdSchema = z.uuid();
export type ChatEventId = z.infer<typeof chatEventIdSchema>;

export const actionIdSchema = z.uuid();
export type ActionId = z.infer<typeof actionIdSchema>;

export const toolIdSchema = z.string();
export type ToolId = z.infer<typeof toolIdSchema>;
